import { render, staticRenderFns } from "./Quotazione.vue?vue&type=template&id=67255a7a&scoped=true&"
import script from "./Quotazione.vue?vue&type=script&lang=js&"
export * from "./Quotazione.vue?vue&type=script&lang=js&"
import style0 from "./Quotazione.vue?vue&type=style&index=0&id=67255a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67255a7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67255a7a')) {
      api.createRecord('67255a7a', component.options)
    } else {
      api.reload('67255a7a', component.options)
    }
    module.hot.accept("./Quotazione.vue?vue&type=template&id=67255a7a&scoped=true&", function () {
      api.rerender('67255a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Quotazione.vue"
export default component.exports